export default __webpack_public_path__ + "static/media/Bandeau 20.63020ac2.jpg";